import { Injectable } from '@angular/core';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root',
})
export class HistoryService {
  constructor(private api: ApiService) {}

  getHistoryListByModuleName(moduleName: string, record_id, pageNumber: number = 1, pageSize: number = 10, searchKeyword = '') {
    return this.api.get(
      `/history/fetch?type=${moduleName}&object_reference=${record_id}&page=${pageNumber}&per_page=${pageSize}&keyword=${searchKeyword}`
    );
  }
  getManualHistoryByPropertyId(propertyId: string) {
    return this.api.get(`/property-manual-history?property_id=${propertyId}`);
  }
  getStreamDetailByModuleName(id: string, moduleName: string, pageNumber: number = 1, pageSize: number = 15, value: string = '') {
    return this.api.get(`/stream/${moduleName}/${id}?page=${pageNumber}&per_page=${pageSize}&keyword=${value}`);
  }
  getPropertyTransactionHistory(property_id: string) {
    return this.api.get('/listing/by-property/' + property_id);
  }
}
